import { render, staticRenderFns } from "./bxgl.vue?vue&type=template&id=23c4e748&scoped=true&"
import script from "./bxgl.vue?vue&type=script&lang=js&"
export * from "./bxgl.vue?vue&type=script&lang=js&"
import style0 from "./bxgl.vue?vue&type=style&index=0&id=23c4e748&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c4e748",
  null
  
)

export default component.exports